@if (entry?.base?.display) {
  <div>
    <app-member-lookup
      [zipSegment]="zipSegment"
      (memberLookupResponse)="onMemberLookupResponse($event)"
      (crosswalkResponse)="onCrosswalkResponse($event)">
    </app-member-lookup>
  </div>
}